//(function () {
//    'use strict';

//    angular.module("imApp").factory("skillsCertificateTableService", [function () {
//        let service = {};

//        return service;
//    }]);
//})();
